import Vue from "vue";
import "./cube-ui";
import "./vant-ui";
import { Notify } from 'vant';
import App from "./App.vue";
import "amfe-flexible";
import router from "./router";
import Router from "vue-router";
import store from "../src/store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconFont/iconfont.css";
import infiniteScroll from "vue-infinite-scroll";
import VCharts from "v-charts";
import VueDND from "awe-dnd";
import vConsole from "vconsole";
import configUrl from './config/configUrl'
import axios from 'axios'
import { ImagePreview } from 'vant';
Vue.use(ImagePreview.Component);
// Vue.prototype.$vConsole = new vConsole();
// import echarts from 'echarts';
// Vue.prototype.$echarts = echarts;
Vue.use(ElementUI);
Vue.use(infiniteScroll);
Vue.use(VCharts);
Vue.use(VueDND);
// Vue.prototype.Dialog = Dialog
//引入中央处理器
import centralControl from "./centralControl/centralControl/centralControl";
Vue.prototype.centralControl = centralControl;
Vue.config.ignoredElements = ["wx-open-launch-weapp"];
Vue.config.productionTip = false;

var toData = {};
var href = "";

// 解决 router duplication 报错
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
//校验函数
function ckeck() {
  var obj = document.cookie;
  return obj.includes("sessionId");
};
import {
  getUserInfoCache,
  getCookie
} from "@/common/api";


// axios.interceptors.request.use(
//   config => {
//     let item = 'LoginUser nUn4PrSMGsrlqyJTKWqKglSXcmZ6iQ594FUlUGr2ecDojCiT4r4rnvj1saOIX9DiwlUDJjxO0NOlSPrm9bm94JfumfWCZPsqVzqHiZlDI6EAgQFWSf37FOjZG53fMtG1';
//     if (item){
//       config.headers['accessToken'] = item;
//     }

//     return config;
//   },
//   error => {
//     return Promise.reject(error.response)   // 返回接口返回的错误信息
//   }

// )

// axios.interceptors.response.use(
//   response => {
//     if (response.data.code=="20880") {
//       // 跳转登陆页面
//       router.push("/")
//       return Message.error(response.data.message)
//     }else{
//       return response;
//     }
//   },
//   error => {
//     return Promise.reject(error.response)   // 返回接口返回的错误信息
//   }

// )
function loginRequest(path, next) {
  let sessionId = getCookie("sessionId");
  if (!localStorage.isLogin || !localStorage.loginInfo) {
    getUserInfoCache({
      sessionId: sessionId //.split("#")[1]
    }).then(res => {
      if (res.code == 200) {
        store.commit("changeLogin", "1");
        localStorage.setItem("loginInfo", JSON.stringify(res.data));
        router.push(path);
      } else {
        next({
          path: "/login", // 未登录则跳转至login页面
        });
      }
    });
  }
  if (path === "/login") {
    getWxCode();
  }
};

var toData = {};
var href = "";

function getWxCode() {
  if (!localStorage.getItem("code")) {
    // //测试环境
    // let appid = "wx084b8ba94fb5f8dc";
    // let redirect_uri = "https://iumswxdev.logimis.com/login";
    // test
    // let appid = "wx084b8ba94fb5f8dc";
    // let redirect_uri = 'https://iumswxtest.logimis.com/login'
    // 生产

    // let appid = "wxfef7cb3b6b68f2e7";
    // let redirect_uri = "https://iumswx.logimis.com/login";

    let appid = localStorage.getItem("appId"); // 西安服务器APPID
    // let redirect_uri = "https://wx.shx.logimis.com/login?appId=" + appid; // 西安服务器地址--测试
    // let redirect_uri = "https://wx.shxasset.logimis.com/login?appId=" + appid; // 西安服务器地址--开发
    // let redirect_uri = "https://wx.union.logimis.com/login?appId=" + appid; // 西安服务器地址
    let redirect_uri = `${configUrl.redirectUri}login?appId=${appid}`;
    let status = "0";
    location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_base&state=${status}#wechat_redirect`;
  }
};

router.beforeEach((to, from, next) => {
  // console.log('path',to.path)
  if (to.query && to.query.appId != null && to.query.appId.length > 0) {
    console.log("set appid " + to.query.appId);
    localStorage.setItem("appId", to.query.appId);
    console.log('appId01', to.query.appId)
  } else {
    console.log("not set appid ");

    if (to.path == '/forget') {      //   解决在登录页点击忘记密码无效bug
      next()
      href = to.path
      document.title = to.meta.title;
      return;
    }
  }
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    let head = document.getElementsByTagName("head");
    let meta = document.createElement("meta");
    meta.content = to.meta.content;

    head[0].appendChild(meta);
  }
  if (to.meta.title) {
    /* 路由发生变化修改页面title */
    document.title = to.meta.title;
  } else {
    let hospitalInfoObj = localStorage.getItem("hospitalInfo");
    if (hospitalInfoObj && hospitalInfoObj != "undefined") {
      let hospitalInfo = JSON.parse(hospitalInfoObj);
      document.title = hospitalInfo.hospitalName
        ? hospitalInfo.hospitalName
        : "";
    } else {
      document.title = "";
    }
  }


  var loginInfo = localStorage.getItem("loginInfo");
  loginInfo = loginInfo ? JSON.parse(loginInfo) : {};
  var flag = false;
  var doubleFlag = false;
  if (!loginInfo.name) {
    var dec = ckeck();
    flag = dec;
    doubleFlag = dec;
    console.log('flag', flag)
  } else {
    flag = true;
  }
  if (to.path == '/login') {
    next();
    return
  }
  if (flag) {
    if (doubleFlag) {
      loginRequest(to.path, next);
    } else {
      if (href != "") {
        //指定跳转
        href = "";
        next({ path: toData.path, query: toData.query });
        //指定跳转结束
      } else {
        next();
      }
    }
  } else {
    //存储参数
    if (to.path !== "/login") {
      toData = JSON.parse(JSON.stringify(to));
      href = to.path;
    }
    //存储参数结束
    next({
      path: "/login", // 未登录则跳转至login页面
    });
  }
});

new Vue({
  render: h => h(App),
  router,
  store
}).$mount("#app");

//禁止 缩放函数
function userScalable() {
  //判断是否是微信登录
  if (
    typeof WeixinJSBridge == "object" &&
    typeof WeixinJSBridge.invoke == "function"
  ) {
    handleFontSize();
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", handleFontSize);
      document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
    }
  }
  //起调网页设置函数
  function handleFontSize() {
    // 设置网页字体为默认大小
    WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
    // 重写设置网页字体大小的事件
    WeixinJSBridge.on("menu:setfont", function () {
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
    });
  }
}
//执行禁止缩放函数
userScalable();
